<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <h5 v-show="!ranfs" class="mb-3">Resumo da Nota</h5>
          <h5 v-show="ranfs" class="mb-3">Resumo do Ranfs</h5>
        </div>
      </div>
    </div>

    <!-- Substituição -->
    <div v-if="substituindo.not_numero" class="row">
      <div class="col-md-4">
        <label>Nota Fiscal a ser substituída</label>
        <p class="font-weight-bold">{{ substituindo.not_numero }}</p>
      </div>
    </div>

    <!-- Tomador Estrangeiro -->
    <div v-if="isEstrangeiro" class="row">
      <div class="col-md-3">
        <label>{{ prestadorORtomador }} Estrangeiro</label>
        <p v-if="tomador.pas_codigo">{{ tomador.pas_codigo.pas_codigo }} - {{ tomador.pas_codigo.pas_nome }}</p>
      </div>
      <div class="col-md-5">
        <label>Nome/Razão Social</label>
        <p>{{ tomador.sep_razao_social_tomador }}</p>
      </div>
      <div class="col-md-3">
        <label>NIF</label>
        <p>{{ tomador.sep_nif_tomador | naoInformado }}</p>
      </div>
      <div class="col-md-4">
        <label>E-mail</label>
        <p>{{ tomador.sep_email_tomador | naoInformado }}</p>
      </div>
    </div>

    <!-- Tomador Brasileiro -->
    <div v-else class="row">
      <div class="col-md-3">
        <label>CPF/CNPJ</label>
        <p>{{ tomador.sep_cpf_cnpj_tomador | cpfCnpj }}</p>
      </div>
      <div class="col-md-5">
        <label>Nome/Razão Social</label>
        <p>{{ tomador.sep_razao_social_tomador }}</p>
      </div>
      <div class="col-md-4">
        <label>E-mail</label>
        <p>{{ tomador.sep_email_tomador | naoInformado }}</p>
      </div>
    </div>

    <!-- Dados do serviço -->
    <div class="row">
      <div class="col-md-3">
        <label>Competência</label>
        <p>{{ competencia.mes }}/{{ competencia.ano }}</p>
      </div>
      <div class="col-md-4">
        <label>Município onde é devido o ISS</label>
        <p>{{ servico.sep_municipio_incidencia.mun_nome }}-{{ servico.sep_municipio_incidencia.mun_uf }}</p>
      </div>
      <div class="col-md-5">
        <label>Município onde o serviço foi prestado</label>
        <p>{{ servico.sep_municipio_prestacao.mun_nome }}-{{ servico.sep_municipio_prestacao.mun_uf }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Cnae</label>
        <p>{{ servico.cnae_codigo?.cnae_codigo }} - {{ servico.cnae_codigo?.cnae_nome }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Atividade desenvolvida</label>
        <p>{{ servico.ser_codigo?.ser_codigo }} - {{ servico.ser_codigo?.ser_descricao }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Nomenclatura Brasileira de Serviços (NBS)</label>
        <p>{{ servico.nbs_codigo?.nbs_codigo }} - {{ servico.nbs_codigo?.nbs_nome }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Operação Tributária</label>
        <p>{{ servico.iop_codigo?.iop_codigo }} - {{ servico.iop_codigo?.iop_nome }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label>Classificação Tributária</label>
        <p>{{ servico.cst_classtrib?.cst_classtrib }} - {{ servico.cst_classtrib?.cst_classtrib_nome }}</p>
      </div>
    </div>

    <!-- Descrição -->
    <div class="row">
      <div class="col-md-12">
        <label>Descrição dos serviço</label>
        <textarea v-model="servico.sep_discriminacao" class="form-control" :disabled="true" rows="15"></textarea>
      </div>
    </div>

    <!-- Resumo de Valores -->
    <div class="row">
      <div class="col-sm-12 mt-2">
        <resumo-calculo
            :valores="valores"
            :sep-iss="sepIss"
            :retencao-federal="retencaoFederal"
            :valor-liquido="valorLiquido"
            iva-label="IVA (Valor Simbólico)"/>
      </div>
    </div>
  </div>
</template>

<script>
import ResumoCalculo from './ResumoCalculo.vue'

export default {
  name: "TabEmissao",
  components: {ResumoCalculo},
  props: {
    tomador: {type: Object, required: true},
    servico: {type: Object, required: true},
    competencia: {type: Object, required: true},
    valores: {type: Object, required: true},
    substituindo: {type: Object, default: () => ({not_hash: null, not_numero: null})},
    isEstrangeiro: {type: Boolean, default: false},
    ranfs: {type: Boolean, default: false},
    sepIss: {type: Number, default: 0},
    retencaoFederal: {type: Number, default: 0},
    valorLiquido: {type: Number, default: 0},
  },
  computed: {
    prestadorORtomador() {
      return !this.ranfs ? "Tomador" : "Prestador";
    },
  },
};
</script>
